import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CryptDataService {

    constructor() { }

    encryptDataSessionSHA256 = ( name: string, data:any, save: boolean) =>{
        try{
            const crypt =  CryptoJS.SHA256( data ).toString();
            save ? this.saveToSession( name, crypt ) : null;
            return crypt;
        } catch (error) {
            console.log('@error encrypt:', error );
        }
    }

    encryptDataSessionAES = ( name: string, data:any, save: boolean) =>{
        try{
            const crypt = CryptoJS.AES.encrypt( JSON.stringify(data), environment.cryptKey ).toString();
            save ? this.saveToSession( name, crypt ) : null;
            return crypt;
        }catch (error) {
            console.log('@error encrypt:', error );
        }
    }

    decryptDataSession = ( data:any ) =>{
        try {
            const bytes = CryptoJS.AES.decrypt(data, environment.cryptKey );
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
        } catch (error) {
            console.log('@error decrypt:', error );
        }
    }

    saveToSession = ( name:string, crypt:string ) => {
        try{
            sessionStorage.setItem( name, crypt );
        }catch(error){
            console.log('@error save ti session:', error );
        }
    }

}
